import { createSlice } from '@reduxjs/toolkit';
import { AuthState } from './types';
import { changeAuthMethodThunk, enable2FAThunk, verify2FAThunk } from './thunk';

const initialState: AuthState = {
  isLoading: false,
  error: null,
  qrCodeData: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    clearQrCode: (state) => {
      state.qrCodeData = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Change Auth Method
      .addCase(changeAuthMethodThunk.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(changeAuthMethodThunk.fulfilled, (state) => {
        state.isLoading = false;
        state.error = null;
      })
      .addCase(changeAuthMethodThunk.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload as string;
      })
      // Enable 2FA
      .addCase(enable2FAThunk.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(enable2FAThunk.fulfilled, (state, action) => {
        state.isLoading = false;
        state.error = null;
        state.qrCodeData = action.payload;
      })
      .addCase(enable2FAThunk.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload as string;
      })
      // Verify 2FA
      .addCase(verify2FAThunk.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(verify2FAThunk.fulfilled, (state) => {
        state.isLoading = false;
        state.error = null;
      })
      .addCase(verify2FAThunk.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload as string;
      });
  },
});

export const { clearError, clearQrCode } = authSlice.actions;
export default authSlice.reducer; 